import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { NgForm } from '@angular/forms';
import * as PerasisEditor from 'libs/ckeditor5-build-perasis';
import { CKEditorConfig } from 'src/app/configs/ckeditor-settings.config';
import { ChangeEvent, CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { StudentModel } from 'src/app/core/models/student.model';
import { TrainingModel } from 'src/app/core/models/training.model';
import { isThisISOWeek, isThisWeek } from 'date-fns';
import { ExcelTemplateModel } from 'src/app/core/models/survey/excel-template.model';
import { ResultModel } from 'src/app/core/models/result.model';

@Component({
  selector: 'app-report-print-assesment',
  templateUrl: './report-print-assesment.component.html',
  styleUrls: ['./report-print-assesment.component.scss']
})
export class ReportPrintAssesmentComponent extends BaseComponent implements OnInit {

  reportDescription: { id: number; title: string; description: string; }[] = [];
  isVisibleDescriptionModal: boolean = false;
  isVisibleDescriptionUpdateModal: boolean = false;
  isVisibleExcelUpdateModal: boolean = false;
  isVisibleNewExcelModal: boolean = false;
  index: number = 0;
  editID: number = 0;
  isLoading: boolean = false;
  isCreating: boolean = false;
  isButton: boolean = false;
  isNewPage: boolean = false;
  Title: string = null;
  Description: string = null;
  studentID: string = null;
  trainingID: string = null;
  reportImageBase64: string = null;

  studentModel: StudentModel = new StudentModel();
  trainingModel: TrainingModel = new TrainingModel();
  model: ExcelTemplateModel = new ExcelTemplateModel();

  @ViewChild('f', { static: false })
  f: NgForm;

  @ViewChild('g', { static: false })
  g: NgForm;
  @ViewChild('h', { static: false })
  h: NgForm;
  @ViewChild('k', { static: false })
  k: NgForm;

   //#region editor start
   public Editor = PerasisEditor;
   @ViewChild('editor', {static: false}) editorComponent: CKEditorComponent;
 
   public EditorConfig = CKEditorConfig;
 
   public onEditorReady(editor) {
     editor.ui.getEditableElement().parentElement.insertBefore(
       editor.ui.view.toolbar.element,
       editor.ui.getEditableElement()
     );
   }
 
   public onEditorChange({ editor }: ChangeEvent) {
     const data = editor.getData();
   }
 
   //#endregion editor end
  allTest: {
    id: number;
    Title: string;
    Description: string;
    Calculate1: number;
    Calculate2: number;
    Calculate3: number;
    Calculate4: number;
    Calculate5: number;
    Percent: number,
    Question: any
  }[] = [];

  allQuestion: {
    QuestionID: number;
    QuestionTitle: string;
    Answer: [
      {
        AnswerID: number;
        IsAnswer: boolean;
      },
      {
        AnswerID: number;
        IsAnswer: boolean;
      },
      {
        AnswerID: number;
        IsAnswer: boolean;
      }, {
        AnswerID: number;
        IsAnswer: boolean;
      }, {
        AnswerID: number;
        IsAnswer: boolean;
      }
    ]
  }[] = [];

  ticariZekaAll = null;
  ngOnInit() {

    this.route.params.subscribe(params => {

      if (params.studentid && params.trainingid) {
        this.studentID = params.studentid;
        this.trainingID = params.trainingid;
        this.model.TrainingID = params.trainingid;

        this.getModel();
      }


    })


  }

  getModel() {
    this.isLoading = true;
    this.mediaService.getReportInfo(this.studentID, this.trainingID)
      .subscribe(result => {

        this.studentModel = result.Student;
        this.trainingModel = result.Training;

        if(result.ExcelTemplate){
          this.ticariZekaAll = JSON.parse(result.ExcelTemplate.Template);

          if(!result.ExcelTemplate.ParticipantID){
            this.ticariZekaAll[0].filter(excel => {
              excel.Calculate1 = 0;
              excel.Calculate2 = 0;
              excel.Calculate3 = 0;
              excel.Calculate4 = 0;
              excel.Calculate5 = 0;
  
              excel.Question.filter(question => {
                question.Answer.filter(answer =>{
                  answer.IsAnswer = false;
                });
              });
            });
          }
          
          
        }
        else{
          this.ticariZekaAll = new Array(this.test);
        }
        console.log(result);
        
        if(result.ExcelTemplate && result.ExcelTemplate.ParticipantID){
          this.isNewPage = true;
          this.reportDescription = JSON.parse(result.ExcelTemplate.TemplateComment);
        }
        else{
          this.reportDescription = [];
        }
        
      },
        error => {
          this.isLoading = false;

        });
  }

  createModel() {
    this.reportDescription.push({ id: this.index, title: this.Title, description: this.Description });
    this.index++;

    this.cancel();

  }
  showUpdateModal(value) {
    this.editID = value;
    this.reportDescription.forEach(element => {

      if (element.id == value) {
        this.Title = element.title;
        this.Description = element.description;
      }

    });

    this.isVisibleDescriptionUpdateModal = true;

  }
  updateModal() {

    this.reportDescription.forEach(element => {

      if (element.id == this.editID) {
        element.title = this.Title;
        element.description = this.Description;
      }

    });

    this.cancel();
  }

  deleteModal() {

    for (var i = 0; i < this.reportDescription.length; i++) {

      if (this.reportDescription[i].id == this.editID) {

        this.reportDescription.splice(i, 1);
      }

    }


    this.cancel();
  }

  cancel() {
    this.isVisibleDescriptionModal = false;
    this.isVisibleDescriptionUpdateModal = false;
    this.isVisibleExcelUpdateModal = false;
    this.isVisibleNewExcelModal = false;
    this.Title = null;
    this.Description = null;
    this.editID = null;
    this.h.resetForm();
    this.k.resetForm();
  }

  htmltoPDF() {
    // parentdiv is the html element which has to be converted to PDF
    html2canvas(document.querySelector("#parentdiv")).then(canvas => {

      var pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);

      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
      pdf.save('rapor.pdf');

    });


  }
  print() {
    window.print();
  }

  //#region
  totalPercent:number = 0;
  totalDegerlendirme:number = 0;
  totalAgirlik:number = 0;
  TitleExcel: string = "";
  DescriptionExcel: string = "";
  Percent: number = 25;
  questions: { questionID: number; questionTitle: string; }[] = [];
  tableCheck(testID, questionID, answerID) {

    var filtered = this.ticariZekaAll[0].filter(test => test.id == testID);

    var filtered2 = filtered[0].Question.filter(questions => questions.QuestionID == questionID);

    filtered2[0].Answer.filter(answers => {

      if (answers.AnswerID == answerID) {
        answers.IsAnswer = true;
      }
      else {
        answers.IsAnswer = false;
      }

    });
    this.calculateTest();
  }

  calculateTest() {
    this.totalPercent = 0;
    this.totalDegerlendirme = 0;
    this.totalAgirlik = 0;

    for (let index = 0; index < this.ticariZekaAll[0].length; index++) {
      this.ticariZekaAll[0][index].Calculate1 = 0;
      this.ticariZekaAll[0][index].Calculate2 = 0;
      this.ticariZekaAll[0][index].Calculate3 = 0;
      this.ticariZekaAll[0][index].Calculate4 = 0;
      this.ticariZekaAll[0][index].Calculate5 = 0;
      this.ticariZekaAll[0][index].Question.forEach(questions => {
   
        questions.Answer.forEach(answer => {
          if (answer.AnswerID == 1 && answer.IsAnswer) {
            this.ticariZekaAll[0][index].Calculate1 += answer.AnswerID;
          }

          if (answer.AnswerID == 2 && answer.IsAnswer) {
            this.ticariZekaAll[0][index].Calculate2 += answer.AnswerID;
          }

          if (answer.AnswerID == 3 && answer.IsAnswer) {
            this.ticariZekaAll[0][index].Calculate3 += answer.AnswerID;
          }

          if (answer.AnswerID == 4 && answer.IsAnswer) {
            this.ticariZekaAll[0][index].Calculate4 += answer.AnswerID;
          }

          if (answer.AnswerID == 5 && answer.IsAnswer) {
            this.ticariZekaAll[0][index].Calculate5 += answer.AnswerID;
          }
        });

      });

      this.totalPercent += this.ticariZekaAll[0][index].Percent;
      this.totalDegerlendirme += (this.ticariZekaAll[0][index].Calculate1 + this.ticariZekaAll[0][index].Calculate2 + this.ticariZekaAll[0][index].Calculate3 + this.ticariZekaAll[0][index].Calculate4 + this.ticariZekaAll[0][index].Calculate5)/this.ticariZekaAll[0][index].Question.length;
      this.totalAgirlik += (this.ticariZekaAll[0][index].Percent *((this.ticariZekaAll[0][index].Calculate1 + this.ticariZekaAll[0][index].Calculate2 + this.ticariZekaAll[0][index].Calculate3 + this.ticariZekaAll[0][index].Calculate4 + this.ticariZekaAll[0][index].Calculate5)/this.ticariZekaAll[0][index].Question.length)/100);
    }
  }
  showCreateExcel() {
    this.editID = null;
    this.TitleExcel = "";
    this.DescriptionExcel = "";
    this.questions = [];
    this.isVisibleNewExcelModal = true;
  }

  createNewExcel() {

    var newID = 1;

    for (let index = 0; index < this.ticariZekaAll[0].length; index++) {
      var element = this.ticariZekaAll[0][index];

      if (element.id >= newID) {
        newID = element.id + 1;
      }

    }
    
    this.allQuestion = [];
    this.allTest = [];
    this.questions.forEach(element => {
      this.allQuestion.push({
        QuestionID: element.questionID,
        QuestionTitle: element.questionTitle,
        Answer: [
          {
            AnswerID: 1,
            IsAnswer: false
          },
          {
            AnswerID: 2,
            IsAnswer: false
          },
          {
            AnswerID: 3,
            IsAnswer: false
          },
          {
            AnswerID: 4,
            IsAnswer: false
          },
          {
            AnswerID: 5,
            IsAnswer: false
          }
        ]
      });
    });

    this.allTest.push({
      id: newID,
      Title: this.TitleExcel,
      Description: this.DescriptionExcel,
      Calculate1: 0,
      Calculate2: 0,
      Calculate3: 0,
      Calculate4: 0,
      Calculate5: 0,
      Percent: this.Percent,
      Question: this.allQuestion,

    })
    
    this.ticariZekaAll[0].push(this.allTest[0]);
    this.cancel();
  }

  showUpdateExcel(value) {
    this.editID = value;
    this.TitleExcel = "";
    this.DescriptionExcel = "";
    this.Percent = 25;
    var test = this.ticariZekaAll[0].filter(element => element.id == value)[0];

    if (test) {

      this.TitleExcel = test.Title;
      this.DescriptionExcel = test.Description;
      this.Percent = test.Percent;
      this.questions = [];

      test.Question.forEach(element => {
        this.questions.push({ questionID: element.QuestionID, questionTitle: element.QuestionTitle });

      });

    }


    this.isVisibleExcelUpdateModal = true;

  }

  addExcelQuestion() {
    var id = 1;
    this.questions.filter(element => {
      if (element.questionID >= id) {
        id = element.questionID + 1;
      }
    })
    this.questions.push({ questionID: id, questionTitle: "" });

  }
  deleteExcelQuestion(id) {
    this.questions = this.questions.filter(element => element.questionID != id);
  }

  updateExcelModel() {

    if (this.editID) {
      for (let index = 0; index < this.ticariZekaAll[0].length; index++) {
        const element = this.ticariZekaAll[0][index];
        if (element.id == this.editID) {

          this.allQuestion = [];
          this.allTest = [];
          this.questions.forEach(element => {
            this.allQuestion.push({
              QuestionID: element.questionID,
              QuestionTitle: element.questionTitle,
              Answer: [
                {
                  AnswerID: 1,
                  IsAnswer: false
                },
                {
                  AnswerID: 2,
                  IsAnswer: false
                },
                {
                  AnswerID: 3,
                  IsAnswer: false
                },
                {
                  AnswerID: 4,
                  IsAnswer: false
                },
                {
                  AnswerID: 5,
                  IsAnswer: false
                }
              ]
            });
          });

          this.allTest.push({
            id: this.editID,
            Title: this.TitleExcel,
            Description: this.DescriptionExcel,
            Calculate1: 0,
            Calculate2: 0,
            Calculate3: 0,
            Calculate4: 0,
            Calculate5: 0,
            Percent: this.Percent,
            Question: this.allQuestion,

          })

          this.ticariZekaAll[0][index] = this.allTest[0];
          break;

        }
      }


    }


    this.cancel();

  }

  deleteExcel() {

    if (this.editID) {

      for (let i = 0; i < this.ticariZekaAll[0].length; i++) {
        const element = this.ticariZekaAll[0][i];

        if (element.id == this.editID) {
          this.ticariZekaAll[0].splice(i, 1);
          break;
        }

      }

    }
    this.cancel();
  }

  addExcelTemplate(){
    this.isCreating = true;
    this.model.Template = JSON.stringify(this.ticariZekaAll);
    this.model.TemplateComment = JSON.stringify(this.reportDescription);
    this.model.ParticipantID = this.studentID;
    
    this.excelTemplateService.create(this.model)
      .subscribe(
        (result) => {
          if (result.Success) { //Student created
            this.isCreating = false;
            this.getModel();
            this.commonFunctionsService.showNotification("success","Şablon kaydı oluşturuldu");
          }
          else {
            this.isCreating = false;
            this.onResult.emit(result);
            this.commonFunctionsService.showNotification("success",result.Message);
          }
        },
        (error) => {
          this.isCreating = false;
          this.commonFunctionsService.showNotification("success","Şablon kaydı oluşturulurken hata meydana geldi",true);
        }
      );
  }

  

  //#endregion
  test = [
    {
      "id": 1,
      "Title": "Ticari Zeka",
      "Description": "Müşterileri ile iletişim kurarken ticari bakış açısını korur. Mevcut durum ve olası fırsatları araştırarak rakipleri ile farklılaşabileceği alanları belirler ve uygular.",
      "Calculate1": 0,
      "Calculate2": 0,
      "Calculate3": 0,
      "Calculate4": 0,
      "Calculate5": 0,
      "Percent": 25,
      "Question": [
        {
          "QuestionID": 1,
          "QuestionTitle": "İş sorunlarını çözmede etkin finansal bilgi, beceri ve metotlar kullanır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 2,
          "QuestionTitle": "Analiz ve teşhis etmede başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 3,
          "QuestionTitle": "Sorunları çözmede kararlıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 4,
          "QuestionTitle": "Kurum stratejilerini iyi anlar, benimser ve attığı her adımda bu stratejileri göz önünde bulundurur",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 5,
          "QuestionTitle": "Risk almada dengeli ve başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 6,
          "QuestionTitle": "Değişimi başlatmada ve hız kazandırmada etkindir",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        }
      ]
    },
    {
      "id": 2,
      "Title": "Müşteri Odaklılık",
      "Description": "Müşterileri ile kurduğu iletişimde onlara değer katan ve bireysel olarak da etkinliğini gösteren bir yaklaşım sergiler. Sunduğu öneriler ve yaklaşımındaki kalite iler ark yaratır.",
      "Calculate1": 0,
      "Calculate2": 0,
      "Calculate3": 0,
      "Calculate4": 0,
      "Calculate5": 0,
      "Percent": 25,
      "Question": [
        {
          "QuestionID": 1,
          "QuestionTitle": "Müşterileri ile verimli ve değer katan ilişkiler kurar, geliştirir",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 2,
          "QuestionTitle": "Müşteri onun danışmanlığından ve uzmanlığından iyi yararlanır ve bundan memnundur.",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 3,
          "QuestionTitle": "Müşteri itiraz ve problemlerini etkin dinler, taleplerini iyi anlar ve sözlerine zamanında döner",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 4,
          "QuestionTitle": "Hizmet kalitesini arttırma yönünde sürekli yeni ve etkili fikirler üretir",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 5,
          "QuestionTitle": "Tavsiyeleri ve kalitesi ile müşterinin saygısını ve güvenini kazanır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        }
      ]
    },
    {
      "id": 3,
      "Title": "Sonuç ve Performans Odaklılık",
      "Description": "Hedef odaklı bir bakış açısına sahiptir. Bununla birlikte hem inisiyatif almaya hazırdır hem de bu süreçte oluşacak baskı durumlarında dirençlidir ve başarıya odaklanarak yönetir.",
      "Calculate1": 0,
      "Calculate2": 0,
      "Calculate3": 0,
      "Calculate4": 0,
      "Calculate5": 0,
      "Percent": 25,
      "Question": [
        {
          "QuestionID": 1,
          "QuestionTitle": "Başarma tutkusu yüksek bir bireydir ",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 2,
          "QuestionTitle": "Özgüveni tamdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 3,
          "QuestionTitle": "Fikirlerini özgürce ifade eder",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 4,
          "QuestionTitle": "Çatışmaları başarı ile yönetmede başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 5,
          "QuestionTitle": "Fikirlerin açıkça tartışılacağı ortamları teşvik eder",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 6,
          "QuestionTitle": "Kendine ulaşılması zorlu ve yüksek hedefler koyar",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 7,
          "QuestionTitle": "Sorumluluk almada ve inisiyatif başlatmada başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 8,
          "QuestionTitle": "Ölçme, değerlendirme ve hedef saptamada etkindir",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 9,
          "QuestionTitle": "Başarı kriterlerine konsantre olmada, diğerlerini de konsantre tutmada başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        }
      ]
    },
    {
      "id": 4,
      "Title": "Ekip Liderliği ve Kişisel Etkinlik",
      "Description": "İletişim becerilerini ve duygusal zekâsını etkin kullanarak ikna kabiliyetini gösterir. Etkin sorgulama becerisi ile de tespitlerini sağlamlaştırır.",
      "Calculate1": 0,
      "Calculate2": 0,
      "Calculate3": 0,
      "Calculate4": 0,
      "Calculate5": 0,
      "Percent": 25,
      "Question": [
        {
          "QuestionID": 1,
          "QuestionTitle": "Diğerleri ile sinerji, uyum ve işbirliği içerisinde çalışarak sonuç alır ",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 2,
          "QuestionTitle": "Farklı profilde insanlar ile iletişim kurmada ve onları kazanmada başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 3,
          "QuestionTitle": "Sunum, yazma ve dinleme becerilerinin etkinliği ile yüksek kredibilite sahibidir",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 4,
          "QuestionTitle": "Üst yönetiminin olmadı yer ve zamanlarda liderliği ele alır, etkin sevk ve idare sergiler",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 5,
          "QuestionTitle": "Diğerlerini motive etmede başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 6,
          "QuestionTitle": "Kendini geliştirmede, kişisel gelişimi için çaba harcamada etkin ve başarılıdır",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        },
        {
          "QuestionID": 7,
          "QuestionTitle": "Çalışanlarını eğitmede, geliştirmede ve idame ettirmede başarılıdır (Koçluk)",
          "Answer": [
            {
              "AnswerID": 1,
              "IsAnswer": false
            },
            {
              "AnswerID": 2,
              "IsAnswer": false
            },
            {
              "AnswerID": 3,
              "IsAnswer": false
            },
            {
              "AnswerID": 4,
              "IsAnswer": false
            },
            {
              "AnswerID": 5,
              "IsAnswer": false
            }
          ]
        }
      ]
    }
  ];
}
